import {useEffect, useRef, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {HtmlRender, ActionLink, AttachedDocumentDownload} from 'shared/components';

const EmailBody = observer(({body, attachments = [], onViewEntireEmail, maxHeight = 500}) => {
  const bodyRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    setOverflowing(bodyRef.current?.scrollHeight > maxHeight);
  }, [body, maxHeight]);

  return (
    <>
      <div ref={bodyRef} className='overflow-hidden w-full' style={{maxHeight}}>
        <HtmlRender html={body}/>
      </div>
      {attachments.length > 0 && <div className='space-y mt2'>
        {attachments.map(attachment => <AttachedDocumentDownload key={attachment.id} doc={attachment}/>)}
      </div>}
      {overflowing && <div className='pt2'>
        <ActionLink onClick={onViewEntireEmail}>
          <FormattedMessage id='recruiting.hiring_funnel.View Entire Email'/>
        </ActionLink>
      </div>}
    </>
  );
});

export default EmailBody;
